import { render, staticRenderFns } from "./Box16.vue?vue&type=template&id=24da8084&scoped=true&"
import script from "./Box16.vue?vue&type=script&lang=js&"
export * from "./Box16.vue?vue&type=script&lang=js&"
import style0 from "./Box16.vue?vue&type=style&index=0&id=24da8084&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24da8084",
  null
  
)

export default component.exports